// extracted by mini-css-extract-plugin
export const headerPanel = "homepage-module--headerPanel--hvMqX";
export const headerDescription = "homepage-module--headerDescription--5ghG6";
export const homeSection = "homepage-module--homeSection--7KHLQ";
export const photo = "homepage-module--photo--3V8RZ";